export default {
  INIT_GOODS_DETAIL: 'INIT_GOODS_DETAIL',
  INIT_ALL_GOODS_DETAIL: 'INIT_ALL_GOODS_DETAIL',
  INIT_ORDERED_DISHES: 'INIT_ORDERED_DISHES',
  SET_GOODS_DETAIL_WITH_RECOMMEND_LIST: 'SET_GOODS_DETAIL_WITH_RECOMMEND_LIST',
  SET_INDUSTRY_INFO: 'SET_INDUSTRY_INFO',
};



// WEBPACK FOOTER //
// ./src/consts/goods-detail-action-type.js